import { render, staticRenderFns } from "./latestDeal.vue?vue&type=template&id=a15023a6&scoped=true&"
import script from "./latestDeal.vue?vue&type=script&lang=js&"
export * from "./latestDeal.vue?vue&type=script&lang=js&"
import style0 from "./latestDeal.vue?vue&type=style&index=0&id=a15023a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15023a6",
  null
  
)

export default component.exports